import {
  DeploymentSchemeFormData,
  DeploymentSchemeFormDataGoal,
  DeploymentSchemeGoal,
  DeploymentSchemeWithGoals,
} from "types/deployment-schemes/deployment-scheme-types";

/**
 * Returns a copy of the deployment scheme with its goals sorted alphabetically by segment name,
 * using the default rules of `localeCompare`.
 *
 * Names that differ only by case are intentionally NOT treated as equal (no `sensitivity: "base"`),
 * so they're ordered deterministically rather than falling back to the arbitrary order returned by the API.
 */
export const sortDeploymentSchemeGoalsBySegmentName = (
  deploymentScheme: DeploymentSchemeWithGoals,
): DeploymentSchemeWithGoals => ({
  ...deploymentScheme,
  goals: [...deploymentScheme.goals].sort((a, b) => a.segment.name.localeCompare(b.segment.name)),
});

/**
 * Creates a DeploymentSchemeFormGoal with given overrides applied.
 */
export const makeDeploymentSchemeFormGoal = (
  overrides: Partial<DeploymentSchemeFormDataGoal> = {},
): DeploymentSchemeFormDataGoal => ({
  segment: [], // Typeahead requires segment to be an array
  pGoal: 0,
  priority: 0,
  ...overrides,
});

/**
 * Creates deployment scheme goals array with given number of goals.
 */
export const makeDeploymentSchemeGoals = (goals: DeploymentSchemeGoal[]): DeploymentSchemeFormDataGoal[] => {
  return goals.map((goal) =>
    makeDeploymentSchemeFormGoal({
      pGoal: goal.pGoal,
      priority: goal.priority,
      segment: [goal.segment],
    }),
  );
};

/**
 * Creates a DeploymentSchemeForm with given overrides applied.
 */
export const makeDeploymentSchemeForm = (
  overrides: Partial<DeploymentSchemeFormData> = {},
): DeploymentSchemeFormData => ({
  label: "",
  description: "",
  goals: [makeDeploymentSchemeFormGoal()],
  ...overrides,
});
